"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleDetailsDisplayWidget = void 0;
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../../commonFunctions");
var FalconAccordion_1 = require("../../../components/FalconAccordion");
var CommonRenderers_1 = require("../../../helpers/CommonRenderers");
var LookupWidgetBase_1 = require("../../LookupWidgetBase");
var services_1 = require("@falcon/services");
var React = require("react");
var VehicleDetailsDisplayWidget = exports.VehicleDetailsDisplayWidget = /** @class */ (function (_super) {
    __extends(VehicleDetailsDisplayWidget, _super);
    function VehicleDetailsDisplayWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VehicleDetailsDisplayWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues("mileage");
    };
    VehicleDetailsDisplayWidget.prototype.render = function () {
        var _this = this;
        var vehicleDetailsSections = [];
        this.props.interaction.vehicles.forEach(function (vehicle) {
            vehicleDetailsSections.push(React.createElement("div", { className: "section-panel text-center" },
                _this.renderVehicleDetails(vehicle),
                _this.renderDrivers(vehicle),
                React.createElement("div", { className: "mt-3 panel-detail-output-entity" },
                    React.createElement(FalconAccordion_1.FalconAccordion, { toggleHidden: React.createElement("div", { className: "toggle" }, "+ Show more"), toggleShown: React.createElement("div", { className: "toggle mt-3" }, "- Show less") },
                        _this.renderExcessSection(vehicle),
                        _this.renderVehicleAdditionalDetailsSection(vehicle)))));
        });
        return (React.createElement(React.Fragment, null, vehicleDetailsSections));
    };
    VehicleDetailsDisplayWidget.prototype.renderVehicleDetails = function (vehicle) {
        return (React.createElement("div", { className: "panel-preview-area" },
            React.createElement("img", { className: "vehicle-icon", alt: "Vehicle icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-car-icon.png") }),
            React.createElement("h2", null,
                vehicle.make,
                ", ",
                vehicle.model),
            React.createElement("div", { className: "number-plate-preview" }, vehicle.registrationNumber)));
    };
    VehicleDetailsDisplayWidget.prototype.renderDrivers = function (vehicle) {
        var mainDriverId = vehicle.mainDriverId;
        var permanentDrivers = [this.props.interaction.policyHolder].concat(this.props.interaction.additionalDrivers || []);
        var vehiclePermanentDrivers = (0, commonFunctions_1.getVehiclePermanentDrivers)(vehicle, permanentDrivers);
        var vehicleTempDrivers = (0, commonFunctions_1.getVehicleTemporaryDrivers)(vehicle, this.props.interaction.temporaryDrivers);
        if (vehiclePermanentDrivers && vehiclePermanentDrivers.length > 0) {
            var drivers = vehiclePermanentDrivers.map(function (driver, i) { return (React.createElement("div", { key: i }, (driver.personId.localeCompare(mainDriverId) === 0) ?
                (React.createElement("div", null,
                    React.createElement("div", { className: "m-0 font-weight-extra-light" },
                        driver.firstName,
                        " ",
                        driver.lastName,
                        " (main driver)"))) : (React.createElement("div", null,
                React.createElement("div", { className: "m-0 font-weight-extra-light" },
                    driver.firstName,
                    " ",
                    driver.lastName,
                    " (additional driver)"))))); });
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "panel-detail-output-entity border-0" },
                    React.createElement("label", { className: "pb-1 m-0" }, "Driver(s)")),
                drivers,
                this.renderTemporaryDrivers(vehicleTempDrivers)));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement("label", null, "Drivers"),
                "There are no drivers added to this car"));
        }
    };
    VehicleDetailsDisplayWidget.prototype.renderTemporaryDrivers = function (vehicleTempDrivers) {
        if (vehicleTempDrivers && vehicleTempDrivers.length > 0) {
            var tempDrivers = vehicleTempDrivers.map(function (tempDriver, i) { return (React.createElement("div", { key: i },
                React.createElement("div", null,
                    React.createElement("div", { className: "m-0 font-weight-extra-light" },
                        tempDriver.firstName,
                        " ",
                        tempDriver.lastName,
                        " (temporary driver)")))); });
            return (React.createElement(React.Fragment, null, tempDrivers));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    VehicleDetailsDisplayWidget.prototype.renderExcessSection = function (vehicle) {
        return (React.createElement("div", { className: "section" },
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "pb-1 m-0" }, "Compulsory excess"),
                (0, CommonRenderers_1.renderDriverCompulsoryExcess)(this.props.interaction, vehicle)),
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "pb-1 m-0" }, "Voluntary excess"),
                React.createElement("div", { className: "m-0 font-weight-extra-light" },
                    "\u00A3",
                    vehicle.excesses.voluntaryExcess)),
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "pb-1 m-0" }, "Guaranteed hire car"),
                React.createElement("div", { className: "m-0 font-weight-extra-light" }, vehicle.extraProtection.courtesyCar ? "Included" : "Not included")),
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "pb-1 m-0" }, "Motor legal expenses"),
                React.createElement("div", { className: "m-0 font-weight-extra-light" }, vehicle.extraProtection.legalProtection ? "Included" : "Not included"))));
    };
    VehicleDetailsDisplayWidget.prototype.renderVehicleAdditionalDetailsSection = function (vehicle) {
        return (React.createElement("div", { className: "section" },
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "pb-1 m-0" }, "Date of purchase"),
                React.createElement("div", { className: "m-0 font-weight-extra-light" }, (0, commonFunctions_1.convertDate)(vehicle.purchaseDate, "MMM YYYY"))),
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "pb-1 m-0" }, "Annual mileage"),
                React.createElement("div", { className: "m-0 font-weight-extra-light" }, this.resolveLookupValue("mileage", vehicle.mileage.toString()))),
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "pb-1 m-0" }, "Overnight post code"),
                React.createElement("div", { className: "m-0 font-weight-extra-light" }, vehicle.overnightLocationIsHome ? this.props.interaction.policyHolder.address.postcode : vehicle.overnightPostcode)),
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "pb-1 m-0" }, "Registered keeper"),
                React.createElement("div", { className: "m-0 font-weight-extra-light" }, (0, commonFunctions_1.getRegisteredKeeper)(this.props.interaction, 0)))));
    };
    VehicleDetailsDisplayWidget = __decorate([
        components_1.authorize
    ], VehicleDetailsDisplayWidget);
    return VehicleDetailsDisplayWidget;
}(LookupWidgetBase_1.LookupWidgetBase));
//# sourceMappingURL=VehicleDetailsDisplayWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/VehicleDetailsDisplayWidget.js
// module id = 2607
// module chunks = 0